import { generatePath, useNavigate } from 'react-router-dom';
import { ClickOutsideDetector, PermissionEnum } from '@ui/src';
import { OrganizationType } from '../../../../hoc/common/types';
import { CardStatus } from '../../../../hoc/common/cards/types';
import getCardStatusIcon from '../helpers/get-card-status-icon';
import { CardItemMenuTypes } from '../types';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';

const CardItemMenu = ({
  setMenuVisible,
  menuVisible,
  setLimitsPanelVisible,
  customerType,
  customerId,
  card,
  activePermissions,
  setConfirmPopupVisible,
  setStatusForChange,
}: CardItemMenuTypes) => {
  const navigate = useNavigate();

  return (
    <ClickOutsideDetector
      setOptionsListVisible={setMenuVisible}
      className={cn.customerCardMenuWrapper}
    >
      <>
        <button
          type="button"
          className={cn.customerCardMenuWrapperButton}
          onClick={() => setMenuVisible(!menuVisible)}
          aria-label="Menu button"
        >
          <span />
        </button>
        {menuVisible && (
          <ul className={cn.customerCardMenu}>
            <li className={cn.customerCardMenuItem}>
              <button
                type="button"
                className={cn.customerCardMenuButton}
                onClick={() => {
                  setMenuVisible(false);
                  setLimitsPanelVisible(true);
                }}
              >
                <span className={cn.statusName}>Limits</span>
              </button>
            </li>
            <li className={cn.customerCardMenuItem}>
              <button
                type="button"
                className={cn.customerCardMenuButton}
                onClick={() => {
                  const link =
                    customerType === OrganizationType.INDIVIDUAL
                      ? ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_ORDER
                      : ROUTES.CUSTOMERS_CORPORATE_CARDS_ORDER;

                  setMenuVisible(false);
                  navigate(
                    generatePath(link, {
                      customerId: customerId as string,
                    }),
                  );
                }}
              >
                <span className={cn.statusName}>Reissue</span>
              </button>
            </li>
            {card.status === CardStatus.ORDERED && (
              <li className={cn.customerCardMenuItem}>
                <button
                  type="button"
                  className={cn.customerCardMenuButton}
                  onClick={() => {
                    const link =
                      customerType === OrganizationType.INDIVIDUAL
                        ? ROUTES.CUSTOMERS_INDIVIDUAL_CARDS_EDIT
                        : ROUTES.CUSTOMERS_CORPORATE_CARDS_EDIT;

                    setMenuVisible(false);
                    navigate(
                      generatePath(link, {
                        customerId: customerId as string,
                        cardId: card.id,
                      }),
                    );
                  }}
                >
                  <span className={cn.statusName}>Edit</span>
                </button>
              </li>
            )}
            {card.availableStatuses?.find(
              (item) => item.value === CardStatus.ACTIVE,
            ) &&
              activePermissions?.includes(
                PermissionEnum.CARDS_ACTIVATE_ACTION,
              ) && (
                <li className={cn.customerCardMenuItem}>
                  <button
                    type="button"
                    className={cn.customerCardMenuButton}
                    onClick={() => {
                      setConfirmPopupVisible(true);
                      setStatusForChange(CardStatus.ACTIVE);
                      setMenuVisible(false);
                    }}
                  >
                    <span className={cn.iconWrapper}>
                      {getCardStatusIcon(CardStatus.ACTIVE)}
                    </span>
                    <span className={cn.statusName}>Activate card</span>
                  </button>
                </li>
              )}

            {card.availableStatuses?.find(
              (item) => item.value === CardStatus.APPROVED,
            ) &&
              activePermissions?.includes(
                PermissionEnum.CARDS_ACCEPT_ACTION,
              ) && (
                <li className={cn.customerCardMenuItem}>
                  <button
                    type="button"
                    className={cn.customerCardMenuButton}
                    onClick={() => {
                      setConfirmPopupVisible(true);
                      setStatusForChange(CardStatus.APPROVED);

                      setMenuVisible(false);
                    }}
                  >
                    <span className={cn.iconWrapper}>
                      {getCardStatusIcon(CardStatus.APPROVED)}
                    </span>
                    <span className={cn.statusName}>Approve card</span>
                  </button>
                </li>
              )}
            {card.availableStatuses?.find(
              (item) => item.value === CardStatus.ORDERED,
            ) && (
              <li className={cn.customerCardMenuItem}>
                <button
                  type="button"
                  className={cn.customerCardMenuButton}
                  onClick={() => {
                    setConfirmPopupVisible(true);
                    setStatusForChange(CardStatus.ORDERED);

                    setMenuVisible(false);
                  }}
                >
                  <span className={cn.iconWrapper}>
                    {getCardStatusIcon(CardStatus.ORDERED)}
                  </span>
                  <span className={cn.statusName}>Order card</span>
                </button>
              </li>
            )}
            {card.availableStatuses?.find(
              (item) => item.value === CardStatus.FROZEN,
            ) &&
              activePermissions?.includes(
                PermissionEnum.CARDS_FREEZE_ACTION,
              ) && (
                <li className={cn.customerCardMenuItem}>
                  <button
                    type="button"
                    className={cn.customerCardMenuButton}
                    onClick={() => {
                      setConfirmPopupVisible(true);
                      setStatusForChange(CardStatus.FROZEN);

                      setMenuVisible(false);
                    }}
                  >
                    <span className={cn.iconWrapper}>
                      {getCardStatusIcon(CardStatus.FROZEN)}
                    </span>
                    <span className={cn.statusName}>Freez card</span>
                  </button>
                </li>
              )}
            {card.availableStatuses?.find(
              (item) => item.value === CardStatus.CANCELED,
            ) &&
              activePermissions?.includes(
                PermissionEnum.CARDS_CANCEL_ACTION,
              ) && (
                <li className={cn.customerCardMenuItem}>
                  <button
                    type="button"
                    className={cn.customerCardMenuButton}
                    onClick={() => {
                      setConfirmPopupVisible(true);
                      setStatusForChange(CardStatus.CANCELED);

                      setMenuVisible(false);
                    }}
                  >
                    <span className={cn.iconWrapper}>
                      {getCardStatusIcon(CardStatus.CANCELED)}
                    </span>
                    <span className={cn.statusName}>Cancel card</span>
                  </button>
                </li>
              )}
          </ul>
        )}
      </>
    </ClickOutsideDetector>
  );
};

export default CardItemMenu;
